import { styled } from "@mui/material/styles";
import FormHelperText from "@mui/material/FormHelperText";

export const ChecklistTypeFormHelperText = styled(FormHelperText)(
  ({ theme }) => ({
    marginLeft: "14px",
    color: theme.palette.error.main,
  })
);
